import { PolicyLetter } from "api/public/policies/policies.types";
import DefaultDataGrid from "components/MUI/DataGrid/DefaultDataGrid";

import { policyLettersColumns } from "./PolicyLetters.columns";

interface PolicyLettersTableProps {
  archived: boolean;
  policies: PolicyLetter[];
  loading: boolean;
}

export default function PolicyLettersTable({
  archived,
  policies,
  loading,
}: PolicyLettersTableProps) {
  const title = `${archived ? "Inactive" : "Active"} Policy Letters`;

  return (
    <DefaultDataGrid
      title={title}
      columns={policyLettersColumns}
      getRowId={(row) => row.policy_num}
      rows={policies}
      loading={loading}
      disableCellFocus
      initialState={{
        sorting: {
          sortModel: [{ field: "policy_num", sort: "desc" }],
        },
      }}
    />
  );
}
